import { render, staticRenderFns } from "./group.vue?vue&type=template&id=da9f1d20&"
import script from "./group.vue?vue&type=script&lang=js&"
export * from "./group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da9f1d20')) {
      api.createRecord('da9f1d20', component.options)
    } else {
      api.reload('da9f1d20', component.options)
    }
    module.hot.accept("./group.vue?vue&type=template&id=da9f1d20&", function () {
      api.rerender('da9f1d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coupon/group.vue"
export default component.exports